import { Home, Folder, Users, ShoppingBag, Package, BookOpen, Settings, Copy, DollarSign, Newspaper, Layers, HelpCircle, Tag } from 'lucide-vue-next'
import type { NavSection } from './types'

export const navSections: NavSection[] = [
  {
    label: 'Prehľad',
    items: [
      { name: 'Dashboard', icon: Home, to: { name: 'Dashboard' } },
    ],
  },
  {
    label: 'Prevádzka',
    items: [
      { name: 'Spoločnosti', icon: Folder, to: { name: 'Úprava spoločností' } },
      { name: 'Klienti', icon: Users, to: { name: 'Úprava klientov' } },
      { name: 'Objednávky', icon: ShoppingBag, to: { name: 'Zoznam objednávok' } },
      { name: 'Zásielky', icon: Package, to: { name: 'Zoznam zásielok' } },
      { name: 'Virtuálne sídla', icon: BookOpen, to: { name: 'VHQ Zoznam' } },
      { name: 'VHQ Management', icon: Settings, to: { name: 'VHQ Management' } },
      { name: 'Ready made firmy', icon: BookOpen, to: { name: 'Ready made firmy' } },
    ],
  },
  {
    label: 'Analytika',
    items: [
      { name: 'Generované doklady', icon: Copy, to: { name: 'Doklady' } },
      { name: 'Prehľad obratu', icon: DollarSign, to: { name: 'Obrat z objednávok' } },
    ],
  },
  {
    label: 'Obsah',
    items: [
      { name: 'Články', icon: Newspaper, to: { name: 'Zoznam článkov' } },
      { name: 'Kategórie článkov', icon: Layers, to: { name: 'Správa kategórií článkov' } },
      { name: 'FAQ', icon: HelpCircle, to: { name: 'Zoznam FAQ' } },
      { name: 'Správa stránok', icon: Layers, to: { name: 'Správa stránok' } },
    ],
  },
  {
    label: 'Ceny',
    items: [
      { name: 'Správa cien', icon: DollarSign, to: { name: 'Správa cien' } },
      { name: 'Kategórie cien', icon: Tag, to: { name: 'Správa kategórií cien' } },
      { name: 'Správa predmetov podnikania', icon: Tag, to: { name: 'Správa predmetov podnikania' } },
      { name: 'Správa kategórií predmetov podnikania', icon: Layers, to: { name: 'Správa kategórií predmetov podnikania' } },
    ],
  },
]
